function e(r){return typeof r=="number"&&!Number.isNaN(r)}export{e as a};
